<div class="col-12 col-sm-12 col-md-8 col-lg-8">
  <div class="table-top-110">
    <!-- <ag-grid-angular
      class="ag-collateral-grid ag-theme-alpine"
      [rowData]="rowData()"
      [columnDefs]="columnDefs()"
      [gridOptions]="gridOptions"
    ></ag-grid-angular> -->
  </div>

  <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 review-button">
    <p><b>Total Pools</b>: {{ countOfCopiedRow }} of 50 max</p>
  </div> -->

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 review-button">
    <button class="button fm-primary-button" (click)="validateCollateralRequest()">REVIEW</button>
  </div>
</div>
